module.exports = __webpack_public_path__ + "img/climate_actions_paper.89f433c.webp";